module.exports = __webpack_public_path__ + "img/4.21b69e29.png";